/* import __COLOCATED_TEMPLATE__ from './datetime-editor.hbs'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
/* RESPONSIBLE TEAM: team-frontend-tech */
import { action } from '@ember/object';
import Component from '@glimmer/component';
let DatetimeEditor = (_class = class DatetimeEditor extends Component {
  constructor() {
    super(...arguments);
    this.comparisonOptions = this.args.predicate.getComparisonOptions({
      mode: this.args.mode
    });
  }
  get relativeComparisonOptions() {
    return this.comparisonOptions.filterBy('type', 'relative').filterBy('direction', this.args.predicate.relativeDirection);
  }
  get optionSuffix() {
    return this.args.predicate.info?.suffix;
  }
  setRelativeValue(event) {
    let value = event.target.value;
    this.args.changePredicateValue({
      ...this.args.predicate.value,
      value
    });
  }
  setRelativeUnit(unit) {
    this.args.changePredicateValue({
      ...this.args.predicate.value,
      unit
    });
  }
}, (_applyDecoratedDescriptor(_class.prototype, "setRelativeValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setRelativeValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setRelativeUnit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setRelativeUnit"), _class.prototype)), _class);
export { DatetimeEditor as default };